"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const dayjs_1 = tslib_1.__importDefault(require("dayjs"));
const vue_demi_1 = require("vue-demi");
const i18n_1 = require("../../../common/i18n");
const fegoProps_1 = require("../../../models/fegoProps");
const __sfc_main = {};
__sfc_main.props = {
    introTitle: {
        type: String,
        default: ''
    },
    mainTitle: {
        type: String,
        default: ''
    },
    pageType: {
        type: String,
        default: fegoProps_1.SignalSelectedPageType.PRIMARY
    },
    updateTime: {
        type: Number,
        default: ''
    },
    languageId: {
        type: Number,
        default: i18n_1.LanguageId.EN
    }
};
__sfc_main.setup = (__props, __ctx) => {
    const props = __props;
    const updateTimeText = (0, vue_demi_1.computed)(() => {
        let text = '';
        if (props.languageId === i18n_1.LanguageId.SC) {
            text = dayjs_1.default.unix(props.updateTime).format('YYYY/MM/DD');
        }
        else if (props.languageId === i18n_1.LanguageId.EN) {
            text = dayjs_1.default.unix(props.updateTime).format('DD/MM/YYYY');
        }
        return text;
    });
    return {
        SignalSelectedPageType: fegoProps_1.SignalSelectedPageType,
        props,
        updateTimeText
    };
};
exports.default = __sfc_main;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTW9kdWxlV3JhcHBlci52dWUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJNb2R1bGVXcmFwcGVyLnZ1ZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFnQ0EsMERBQTBCO0FBQzFCLHVDQUFvQztBQUNwQywrQ0FBa0Q7QUFDbEQseURBQW1FO0FBQ25FLE1BQU0sVUFBVSxHQUFHLEVBQUUsQ0FBQztBQUN0QixVQUFVLENBQUMsS0FBSyxHQUFHO0lBQ2pCLFVBQVUsRUFBRTtRQUNWLElBQUksRUFBRSxNQUFNO1FBQ1osT0FBTyxFQUFFLEVBQUU7S0FDWjtJQUNELFNBQVMsRUFBRTtRQUNULElBQUksRUFBRSxNQUFNO1FBQ1osT0FBTyxFQUFFLEVBQUU7S0FDWjtJQUNELFFBQVEsRUFBRTtRQUNSLElBQUksRUFBRSxNQUFNO1FBQ1osT0FBTyxFQUFFLGtDQUFzQixDQUFDLE9BQU87S0FDeEM7SUFDRCxVQUFVLEVBQUU7UUFDVixJQUFJLEVBQUUsTUFBTTtRQUNaLE9BQU8sRUFBRSxFQUFFO0tBQ1o7SUFDRCxVQUFVLEVBQUU7UUFDVixJQUFJLEVBQUUsTUFBTTtRQUNaLE9BQU8sRUFBRSxpQkFBVSxDQUFDLEVBQUU7S0FDdkI7Q0FDRixDQUFDO0FBQ0YsVUFBVSxDQUFDLEtBQUssR0FBRyxDQUFDLE9BQU8sRUFBRSxLQUFLLEVBQUUsRUFBRTtJQUNwQyxNQUFNLEtBQUssR0FBRyxPQUFPLENBQUM7SUFDdEIsTUFBTSxjQUFjLEdBQUcsSUFBQSxtQkFBUSxFQUFDLEdBQUcsRUFBRTtRQUNuQyxJQUFJLElBQUksR0FBRyxFQUFFLENBQUM7UUFDZCxJQUFJLEtBQUssQ0FBQyxVQUFVLEtBQUssaUJBQVUsQ0FBQyxFQUFFLEVBQUUsQ0FBQztZQUN2QyxJQUFJLEdBQUcsZUFBSyxDQUFDLElBQUksQ0FBQyxLQUFLLENBQUMsVUFBVSxDQUFDLENBQUMsTUFBTSxDQUFDLFlBQVksQ0FBQyxDQUFDO1FBQzNELENBQUM7YUFBTSxJQUFJLEtBQUssQ0FBQyxVQUFVLEtBQUssaUJBQVUsQ0FBQyxFQUFFLEVBQUUsQ0FBQztZQUM5QyxJQUFJLEdBQUcsZUFBSyxDQUFDLElBQUksQ0FBQyxLQUFLLENBQUMsVUFBVSxDQUFDLENBQUMsTUFBTSxDQUFDLFlBQVksQ0FBQyxDQUFDO1FBQzNELENBQUM7UUFDRCxPQUFPLElBQUksQ0FBQztJQUNkLENBQUMsQ0FBQyxDQUFDO0lBQ0gsT0FBTztRQUNMLHNCQUFzQixFQUF0QixrQ0FBc0I7UUFDdEIsS0FBSztRQUNMLGNBQWM7S0FDZixDQUFDO0FBQ0osQ0FBQyxDQUFDO0FBQ0Ysa0JBQWUsVUFBVSxDQUFDIn0=